import { z } from '../zod';
import { TicketTypeResponseValidationSchema } from '../event-page/response';

export const TicketTypeEnvelopeResponseValidationSchema = z
  .object({
    data: TicketTypeResponseValidationSchema,
  })
  .openapi('TicketTypeEnvelopeResponse');
